export const colorTokens = [
  { name: 'Black', value: 'var(--black, #000000)' },
  { name: 'White', value: 'var(--white, #ffffff)' },
  { name: 'Gray 50', value: 'var(--gray-50, #eeeeee)' },
  { name: 'Gray 100', value: 'var(--gray-100, #dddddd)' },
  { name: 'Gray 200', value: 'var(--gray-200, #bbbbbb)' },
  { name: 'Gray 300', value: 'var(--gray-300, #999999)' },
  { name: 'Gray 400', value: 'var(--gray-400, #777777)' },
  { name: 'Gray 500', value: 'var(--gray-500, #555555)' },
  { name: 'Gray 600', value: 'var(--gray-600, #444444)' },
  { name: 'Gray 700', value: 'var(--gray-700, #333333)' },
  { name: 'Gray 800', value: 'var(--gray-800, #222222)' },
  { name: 'Gray 900', value: 'var(--gray-900, #111111)' },
  { name: 'Primary 50', value: 'var(--primary-50, #ebf5ff)' },
  { name: 'Primary 100', value: 'var(--primary-100, #e1effe)' },
  { name: 'Primary 200', value: 'var(--primary-200, #c3ddfd)' },
  { name: 'Primary 300', value: 'var(--primary-300, #a4cafe)' },
  { name: 'Primary 400', value: 'var(--primary-400, #76a9fa)' },
  { name: 'Primary 500', value: 'var(--primary-500, #3f83f8)' },
  { name: 'Primary 600', value: 'var(--primary-600, #1c64f2)' },
  { name: 'Primary 700', value: 'var(--primary-700, #1a56db)' },
  { name: 'Primary 800', value: 'var(--primary-800, #1e429f)' },
  { name: 'Primary 900', value: 'var(--primary-900, #233876)' },
  { name: 'Designer Black', value: 'var(--designer-black, #1a1a1a)' },
  { name: 'Designer White', value: 'var(--designer-white, #f5f5f5)' },
  { name: 'Designer Gray', value: 'var(--designer-gray, #bbbbbb)' },
  {
    name: 'Designer Enverse Blue (Dark)',
    value: 'var(--designer-blue, #0066cc)',
  },
];
